<template>
  <Weather />
</template>

<script>
import { defineComponent } from "vue";
import Weather from "@/components/Weather.vue";

export default defineComponent ({
  components: {Weather},
  setup() {
    return {
      
    }
  }
})
</script>

<style>

</style>